import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=56415b20&scoped=true"
import script from "./home.js?vue&type=script&lang=js&external"
export * from "./home.js?vue&type=script&lang=js&external"
import style0 from "./home.scss?vue&type=style&index=0&id=56415b20&prod&lang=scss&scoped=true&external"
import style1 from "./global.scss?vue&type=style&index=1&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56415b20",
  null
  
)

export default component.exports